<template>
<div>
    <p v-if="!registration.registered()">Sie sind nicht für denn Wettbewerb angemeldet</p>

    <p v-else-if="this.competition.getTransferEnd().isBefore()">
      Der Wettbewerb ist beendet
    </p>

    <p v-else-if="!competition.transferAllowed()">
      Ergebnisse des papierbasierten Wettbewerbes können vom
      {{ this.competition.getTransferStart().format('D. MMMM') }} bis zum
      {{ this.competition.getTransferEnd().format('D. MMMM') }} eingetragen werden
    </p>

    <div v-else>
      <p>Hier können Sie die Ergebnisse des papierbasierten Wettbewerbes eintragen:</p>
      <b-button variant="primary" size="sm" :disabled="!this.competition.transferAllowed()"
          v-on:click="$refs.paperResultModal.show()">
        Ergebnis eintragen
      </b-button>
    </div>


    <!-- MODALS -->
    <paper-result-modal
            ref="paperResultModal"
            v-bind:competitionId="competition.id"
            v-bind:registrationId="registration.id">
    </paper-result-modal>

</div>
</template>
<script>
import PaperResultModal from '@/components/competitions/details/PaperResultModal'

export default {
  name: 'Paper',
  props: ['competition', 'registration'],
  components: {
    paperResultModal: PaperResultModal
  },

  methods: {
    editResult (row) {
      this.$refs.paperResultModal.show(row)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/details/Paper.vue